import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_right",
  "use": "icon-icon_right-usage",
  "viewBox": "0 0 7 14",
  "content": "<symbol viewBox=\"0 0 7 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_right\">\n<path d=\"M1 1.10059L6 6.85272L1 12.6049\" stroke=\"\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol